export default __webpack_public_path__ + "static/media/Keg of Asgardian Stout.6d3cf5dc.jpg";